// import React, { Component } from 'react';
// import { InputText } from 'primereact/inputtext';
// import { connect } from 'react-redux';
// import { Dropdown } from 'primereact/dropdown';
// import { InputSwitch } from 'primereact/inputswitch';
// import { Toast } from 'primereact/toast';
// import { Checkbox } from 'primereact/checkbox';
// import { Calendar } from 'primereact/calendar';
// import { RadioButton } from 'primereact/radiobutton';
// import { MultiSelect } from 'primereact/multiselect';
// import { Button } from 'primereact/button';
// import UploadImage from '../../../assets/images/uploadImg.svg';
// import Messages from '../../../shared/UI/Messages/Messages';
// import axios from '../../../axios-url';
// import DynamicDataTable from '../../../components/DynamicDataTable/DynamicDataTable';

// import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
// import { DataTable } from 'primereact/datatable';
// import { Column } from 'primereact/column';
// import { DATATABLE_CONFIG, DROPDOWN_CONFIG, HOLIDAY_SUBMENU_ID } from '../../../shared/Config';
// import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
// import * as actions from '../../../store/actions/index';
// import { DateFormetter, scrollToTop } from '../../../shared/utility';

// class MaterialRequirementPlanning extends Component {
//     state = {
//         roles: [],
//         type: 'add',
//         Id: null,
//         UserId: null,
//         EmployeeId: null,
//         RoleId: null,
//         functionalRoleId: [],
//         functionalRoleOptions: [],
//         approvalroles: [],
//         approvalRoleId: null,
//         UserId1: '',
//         FirstName: '',
//         MiddleName: '',
//         LastName: '',
//         EmailId: '',
//         Password: '',
//         MobileNumber: '',
//         Activedirectory: false,
//         Adloginid: '',
//         Disablelogin: false,
//         IsActive: false,
//         createdBy: (this.props.loggedUserDetail.userName) ?? 'Admin',
//         createdDate: new Date(),
//         CompanyId: this.props.loggedUserDetail.CompanyId,
//         touch: false,
//         fromRawMaterialRows: [],
//         toRawMaterialRows: [],

//         Menuitems: [],
//         rowSeq: 0,
//         recipeDetails: [],
//         fromDate: null,
//         toDate: null,
//         branch: '',
//         restaurantId: null,
//         restaurantOptions: [],
//     }

//     componentDidMount() {
//         this.getAccess = HASACCESS(HOLIDAY_SUBMENU_ID);
//         let id = this.props.match.params.id;
//         this.props.getMasterTableList('GeUsers?id=' + id);
//         this.props.getMasterKeywordList('Role');
//         this.props.getMasterKeywordList('Employee');
//         this.props.getMasterKeywordList('ApprovalRole');

//         this.props.getMasterKeywordList('MenuItem');
//         this.props.getMasterKeywordList('Uom');
//         this.props.getMasterKeywordList('Ingredient');
//         this.props.getMasterKeywordList('branch');
//         let type = this.props.match.params.type;

//         axios.get('/master/api/DropDownValues/FRole')
//             .then(response => {
//                 if (response.status === 200) {
//                     let data = []
//                     if (response.data && response.data.length > 0) {
//                         data = response.data.map(list => {
//                             let value = list.id;
//                             let id = list.id;
//                             let text = list.text
//                             return { label: text, value: value.toString(), id: id };
//                         })
//                     }
//                     this.setState({ functionalRoleOptions: data })
//                 }
//             }
//             )
//             .catch(err => {
//                 this.growl.show({ severity: 'error', summary: null, detail: 'Functional Roles Api Failed' });
//             })

//         if (type !== 'add') {
//             this.timer();
//         }
//     }

//     timer = () => {
//         this.intervalID = setInterval(() => {
//             this.fetchSingleProcess();
//         }, 2000)
//     }

//     componentWillUnmount() {
//         if (this.props.tableLists.usersList !== undefined) {
//             clearInterval(this.intervalID);
//         }
//     }

//     fetchSingleProcess = () => {
//         let id = this.props.match.params.id;
//         let type = this.props.match.params.type;
//         let storageItems = [];
//         if (this.props.tableLists.usersList !== undefined) {
//             storageItems = this.props.tableLists.users;
//             clearInterval(this.intervalID);
//         }
//         if (storageItems) {
//             let filterData = storageItems;
//             if (filterData) {
//                 let roles = '';
//                 let functionalRoles = '';
//                 let approvalroles = '';
//                 if (filterData.roleAssigned != null) {
//                     roles = filterData.roleAssigned.split(",")
//                 }
//                 if (filterData.functionalRole != null) {
//                     functionalRoles = filterData.functionalRole.split(",")
//                 }
//                 if (filterData.approvalrole != null) {
//                     approvalroles = filterData.approvalrole.split(",")
//                 }
//                 var data = {
//                     type: type,
//                     Id: filterData.id,
//                     UserId: filterData.userId,
//                     EmployeeId: filterData.employeeId,
//                     RoleId: roles,
//                     approvalRoleId: approvalroles,
//                     UserId1: filterData.userid1,
//                     FirstName: filterData.firstName,
//                     functionalRoleId: functionalRoles,
//                     MiddleName: filterData.middleName,
//                     LastName: filterData.lastName,
//                     EmailId: filterData.emailId,
//                     Password: filterData.password,
//                     MobileNumber: filterData.mobileNumber,
//                     Activedirectory: filterData.activedirectory,
//                     Adloginid: filterData.adloginid,
//                     Disablelogin: filterData.disablelogin,
//                     IsActive: filterData.isActive,
//                     CreatedBy: filterData.createdby,
//                     CreatedDate: filterData.createddate,
//                 }
//                 this.setState(data);
//             }
//         }
//     }

//     change = (e) => {
//         let { name, value } = e.target;
//         this.setState({ [name]: value, touch: true })
//     }

//     add = () => {
//         if (this.state.EmployeeId === null) {
//             this.growl.show({ severity: 'error', summary: null, detail: 'Employee is required' });
//             return;
//         } else if (this.state.RoleId === null || this.state.RoleId === '') {
//             this.growl.show({ severity: 'error', summary: null, detail: 'Role is required' });
//             return;
//         } else if (this.state.UserId1 === "") {
//             this.growl.show({ severity: 'error', summary: null, detail: 'UserName is required' });
//             return;
//         } else if (this.state.FirstName === "") {
//             this.growl.show({ severity: 'error', summary: null, detail: 'FirstName is required' });
//             return;
//         } else if (this.state.LastName === "") {
//             this.growl.show({ severity: 'error', summary: null, detail: 'LastName is required' });
//             return;
//         } else if (this.state.EmailId === "" || this.state.EmailId === null) {
//             this.growl.show({ severity: 'error', summary: null, detail: 'EmailId is required' });
//             return;
//         } else if (this.state.Password === "") {
//             this.growl.show({ severity: 'error', summary: null, detail: 'Password is required' });
//             return;
//         } else if (this.state.MobileNumber === "" || this.state.MobileNumber === null) {
//             this.growl.show({ severity: 'error', summary: null, detail: 'MobileNumber is required' });
//             return;
//         } else if (this.state.approvalRoleId === "" || this.state.approvalRoleId === null) {
//             this.growl.show({ severity: 'error', summary: null, detail: 'Approval Roleid is required' });
//             return;
//         } else if (this.state.functionalRoleId === "" || this.state.functionalRoleId === null) {
//             this.growl.show({ severity: 'error', summary: null, detail: 'functional Roleid is required' });
//             return;
//         }

//         var data = {
//             EmployeeId: this.state.EmployeeId,
//             RoleId: null,
//             UserId1: this.state.UserId1,
//             FirstName: this.state.FirstName,
//             FunctionalRole: this.state.functionalRoleId.join(),
//             Approvalrole: this.state.approvalRoleId.join(),
//             MiddleName: this.state.MiddleName,
//             LastName: this.state.LastName,
//             EmailId: this.state.EmailId,
//             Password: this.state.Password,
//             MobileNumber: this.state.MobileNumber,
//             RoleAssigned: this.state.RoleId.join(),
//             Activedirectory: this.state.Activedirectory,
//             Adloginid: this.state.Adloginid,
//             Disablelogin: this.state.Disablelogin,
//             IsActive: this.state.IsActive,
//             CompanyId: this.state.CompanyId,
//             CreatedBy: this.state.createdBy,
//             CreatedDate: this.state.createdDate,
//             FromRawMaterials: this.state.fromRawMaterialRows,
//             ToRawMaterials: this.state.toRawMaterialRows
//         }

//         if (this.state.type === 'edit') {
//             data.UserId = this.state.UserId;
//             data.Id = this.state.Id
//         }

//         this.props.processDynamicData('user', this.state.type, data, 'GeUsers');
//     }

//     resetData = () => {
//         var data = {
//             UserId: null,
//             EmployeeId: null,
//             RoleId: null,
//             functionalRoleId: null,
//             approvalRoleId: null,
//             UserId1: '',
//             FirstName: '',
//             MiddleName: '',
//             LastName: '',
//             EmailId: '',
//             Password: '',
//             MobileNumber: '',
//             Activedirectory: false,
//             Disablelogin: false,
//             IsActive: false,
//             type: 'add',
//             fromRawMaterialRows: [],
//             toRawMaterialRows: [],

//             Menuitems: [],
//             rowSeq: 0,
//             recipeDetails: [],
//             fromDate: null,
//             toDate: null,
//             branch: ''
//         }
//         this.setState(data);
//     }

//     calculate = () => {
//         console.log(this.state.rows)
//     }

//     handleChange = (e) => {
//         this.setState({ [e.target.name]: e.target.value, touch: true });
//     }

//     editItem = (rowData, type) => {
//         scrollToTop();
//         let date = rowData.dates;
//         let splitDate = date.split(",");
//         let res = [];
//         if (splitDate.length > 1) {
//             res[0] = new Date(splitDate[0]);
//             res[1] = new Date(splitDate[splitDate.length - 1]);
//         } else {
//             res[0] = new Date(splitDate[0]);
//             res[1] = null
//         }

//         const newValue = [...this.state.holidayArray];
//         newValue[0]['name'] = rowData.name;
//         newValue[0]['year'] = rowData.year;
//         newValue[0]['dates'] = res;
//         newValue[0]['isActive'] = rowData.isActive;

//         this.setState({
//             type: type,  // 'edit' or 'view'
//             holidayid: rowData.holidayid,
//             patternName: rowData.description,
//             patternID: rowData.patternID,
//             holidayArray: newValue,
//             CreatedBy: rowData.createdBy,
//             CreatedDate: rowData.createdDate
//         });
//     }
//     actionTemplate = (rowData, column) => {
//         return <div className="actionCenter">
//             {(this.getAccess !== undefined && this.getAccess.editAccess !== false) &&
//                 <Button
//                     onClick={() => this.editItem(rowData, 'edit')}  // ✅ Edit button is here
//                     type="button"
//                     icon="pi pi-pencil"
//                     className="p-button-info"
//                 />
//             }

//             {/* View and Delete buttons */}

//             {(this.getAccess !== undefined && this.getAccess.viewAccess !== false) &&
//                     <Button onClick={() => this.editItem(rowData, 'view')} type="button" icon="pi pi-eye" className="p-button-secondary" ></Button>
//                 }
//         </div>;
//     }
//        addRow = () => {
//         let newRow = {
//             rowId: this.state.rowSeq,
//             Item: '',
//             Quantity: '',
//             Unit: null
//         };

//         this.setState({
//             Menuitems: [...this.state.Menuitems, newRow],
//             rowSeq: this.state.rowSeq + 1,
//             touch: true
//         });
//     }

//     removeRow = (rowData) => {
//         let excludeIds = [rowData.rowId, ...this.getDescendantIds(rowData.rowId)];
//         let Menuitems = this.state.Menuitems.filter(row => !excludeIds.includes(row.rowId));
//         this.setState({ Menuitems, touch: true });
//     }

//         ItemTemplate = (rowData) => {
//             return (
//                 <Dropdown
//                     placeholder="Select Item"
//                     showClear
//                     options={this.props.MenuItem}
//                     value={rowData.Item}
//                     onChange={(e) => this.rowChange(e, rowData, 'Item')}
//                     optionLabel="label"
//                     optionValue="value"
//                     {...DROPDOWN_CONFIG}
//                 />
//             );
//         }
    
//         // QuantityTemplate = (rowData) => {
//         //     return (
//         //         <InputText className="p-col-12" value={rowData.Quantity} placeholder="Quantity" onChange={(e) => this.rowChange(e, rowData, 'Quantity')} />
    
//         //     );
//         // }
    
//         QuantityTemplate = (rowData) => {
//             return (
//                 <InputText
//                     className="p-col-12"
//                     value={rowData.Quantity}
//                     placeholder="Quantity"
//                     onChange={(e) => this.rowChange(e, rowData, 'Quantity')}
//                 />
//             );
//         }

//     render() {
//         if (this.props.success) {
//             REDIRECT_TO_URL('/users/', this.props);
//         }

//         let addAccess = true;
//         let editAccess = true;
//         if (this.getAccess !== undefined) {
//             if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) {
//                 this.props.history.push('/dashboard')
//             }
//             addAccess = (this.getAccess.addAccess === true) ? true : false;
//             editAccess = (this.getAccess.editAccess === true) ? true : false;
//         }
//         let accessButton = { addAccess: addAccess, editAccess: editAccess }

//         let isEnabled = (this.state.touch === true);
//         let redirectURL = '/users/';

//         if (this.props.userDetail && this.props.match.params.id !== undefined) {
//             if (this.props.userDetail.userId === this.props.match.params.id) {
//                 redirectURL = "/dashboard";
//             }
//         }

//         const INDENT_MANAGEMENT = [
//             { id: 1, name: 'Test_item' },
//             { id: 2, name: 'Test_idli' },
//             { id: 3, name: 'Test_dosa' }
//         ];

//         const metaData = {
//             'Indentmanagement': INDENT_MANAGEMENT.map(d => ({
//                 label: d.name,
//                 value: d.id
//             })),
//         };

//         const fields = [
//             {
//                 fieldName: 'Item',
//                 fieldDescription: 'Item',
//                 fieldType: 2,
//                 required: true
//             },
//             {
//                 fieldName: 'Quantity',
//                 fieldDescription: 'Quantity',
//                 fieldType: 1,
//                 required: true
//             }
//         ]

//         const header = (
//             <div style={{ 'textAlign': 'right' }}>
//                 <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Search..." />
//             </div>
//         );

//         const tableData = [
//             {
//                 id: "1",
//                 name: "cocunut",
//                 requiredquantity: "1",
//                 stockquantity: "100",
//                 purchasequantity: "0",
//             },
//             {
//                 id: "2",
//                 name: "rice",
//                 requiredquantity: "5",
//                 stockquantity: "20",
//                 purchasequantity: "0",
//             },
//             {
//                 id: "3",
//                 name: "wheat",
//                 requiredquantity: "10",
//                 stockquantity: "50",
//                 purchasequantity: "0",
//             }
//         ];



//         // const actionTemplate = (rowData, column) => {
//         //     return <div className="actionCenter">
//         //         {(this.getAccess !== undefined && this.getAccess.editAccess !== false) &&
//         //             <Button onClick={() => this.editItem(rowData, 'edit')} type="button" icon="pi pi-pencil" className="p-button-info" ></Button>
//         //         }





//         return (
//             <div className="p-grid">
//                 {this.props.loading && <div className="page-loader"></div>}
//                 {this.props.error !== null && <Messages type="error" message={this.props.error} />}
//                 {this.props.success !== null && <Messages type="success" message={this.props.success} />}
//                 <Toast ref={(el) => this.growl = el} />

//                 <div className="p-col-12">
//                     <div className="card card-w-title" style={{ position: 'relative' }}>
//                         <div className="p-grid mt1">
//                             <div className="p-col-12">
//                                 <div className="card card-w-title">
//                                     <h1>Material Requirement Planning</h1>


//                                 </div>

//                                 <div className="p-col-12" style={{ marginTop: '20px' }}>

//                         <div className="p-grid mt1" style={{ marginTop: '20px' }}>
//                             <div className="p-col-12">
//                                 <div className="p-col-12" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                     <h3 style={{ borderBottom: '2px solid #d0d0d0', paddingBottom: '6px', marginBottom: '10px', marginTop: '10px', flex: 1 }}>Menu</h3>
//                                     <Button label="Add Row" icon="pi pi-plus" className="p-button-success" onClick={this.addRow} style={{ marginLeft: '10px' }} />
//                                 </div>
//                                 <div className="p-grid" style={{ marginTop: '20px' }}>
//                                     <div className="p-col-12">
//                                         <DataTable value={this.state.Menuitems} dataKey="rowId" responsiveLayout="scroll">
//                                             <Column field="Item" header="Menu Item" body={this.ItemTemplate} />
//                                             <Column field="Quantity" header="Quantity" body={this.QuantityTemplate} />
//                                             {/* <Column field="Unit" header="Unit" body={this.UnitTemplate} /> */}

//                                             <Column header="Action" body={this.actionTemplate} />
//                                         </DataTable>


//                                         {/* Buttons Section */}
//                                         <div style={{ marginTop: '20px', textAlign: 'right' }}>
//                                             <Button label="Reset" className="p-button-secondary" onClick={this.resetData} style={{ marginRight: '10px' }} />
//                                             <Button label="Calculate" className="p-button-secondary" onClick={this.calculate} />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="p-col-12" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                     <h3 style={{ borderBottom: '2px solid #d0d0d0', paddingBottom: '6px', marginBottom: '10px', marginTop: '10px', flex: 1 }}>Ingredients</h3>
//                                 </div>
//                                 <DataTable ref={(el) => this.dt = el} value={this.state.recipeDetails} globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG} >


//                                     <Column field="Item" header="Ingredient name" body={(row) => this.resolveLabel(this.props.Ingredient, row.Item)}  />
//                                     <Column field="Quantity" header="Quantity" />
//                                     <Column field="Unit" header="Unit"body={(row) => this.resolveLabel(this.props.Uom, row.Unit)}  />
//                                     {/* <Column field="purchasequantity" header="Purchase Quantity" /> */}
//                                     <Column body={this.actionTemplate} header="Action" />

//                                 </DataTable>


//                             </div>
//                         </div>
//                                 </div>

//                                 <Button style={{ float: 'right' }} label="Reset" className="ml1 p-button-secondary" onClick={this.resetData} />
//                                 <Button style={{ float: 'right' }} label="Calculate" className="ml1 p-button-secondary" onClick={this.calculate} />
//                             </div>
//                         </div>
//                     </div>


//                     <div className="card p-col-12" style={{ marginTop: '2em' }}>

//                         <div className="p-grid">
//                             <div className="p-col-12 p-md-6 p-lg-6">
//                                 <div className="mt1 ">
//                                     <InputText className="width100" placeholder="Name" name="patternName" value={this.state.patternName} onChange={this.changeKey} readOnly />
//                                 </div>
//                             </div>

//                             <div className="p-col-12 p-md-6 p-lg-6">
//                                 <div className="mt1 ">
//                                     <InputText className="width100" placeholder="Required Quantity" name="patternID" value={this.state.patternID} onChange={this.changeKey} readOnly />
//                                 </div>
//                             </div>

//                             <div className="p-col-12 p-md-6 p-lg-6">
//                                 <div className="mt1 ">
//                                     <InputText className="width100" placeholder="Stock Purchase" name="patternName" value={this.state.patternName} onChange={this.changeKey} readOnly />
//                                 </div>
//                             </div>

//                             <div className="p-col-12 p-md-6 p-lg-6">
//                                 <div className="mt1 ">
//                                     <InputText className="width100" placeholder="Purchase Quantity" name="patternName" value={this.state.patternName} onChange={this.changeKey} />
//                                 </div>
//                             </div>

//                             <div className="p-col-12 p-md-6 p-lg-12">
//                                 {/* <FooterButton access={accessButton} disabled={false} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData} to={"/employee-master/"} /> */}
//                                 <Button style={{ float: 'right' }} label="Update" className="ml1 p-button-secondary" onClick={this.updateData} />

//                             </div>

//                         </div>



//                         <DataTable ref={(el) => this.dt = el} value={tableData} globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG} >


//                             <Column field="name" header="name" />
//                             <Column field="requiredquantity" header="Required Quantity" />
//                             <Column field="stockquantity" header="Stock Quantity" />
//                             <Column field="purchasequantity" header="Purchase Quantity" />
//                             <Column body={this.actionTemplate} header="Action" />
//                         </DataTable>
//                     </div>
//                 </div>
//             </div>
//         ); // <-- Closing return parentheses
//     } // <-- Closing render method
// } // <-- Closing MaterialRequirementPlanning class

// const mapStateToProps = state => {
//     return {
//         loggedUserDetail: state.auth.userObject,
//         userDetail: state.auth.userDetail,
//         userPref: state.auth.userPref,
//         GetEmployeedropdown: (state.keyword.Employee !== undefined) ? state.keyword.Employee : [],
//         loading: state.master.loading,
//         error: state.master.error,
//         success: state.master.success,
//         Role: (state.keyword.Role !== undefined) ? state.keyword.Role : [],
//         ApprovalRole: (state.keyword.ApprovalRole !== undefined) ? state.keyword.ApprovalRole : [],
//         tableLists: state.master.tableLists,
//         MenuItem:   (state.keyword.MenuItem   !== undefined) ? state.keyword.MenuItem   : [],
//         Uom:        (state.keyword.Uom        !== undefined) ? state.keyword.Uom        : [],
//         Ingredient: (state.keyword.Ingredient !== undefined) ? state.keyword.Ingredient : [],
//         branch:     (state.keyword.branch     !== undefined) ? state.keyword.branch     : [],
//     }
// }

// const mapDispatchToProps = dispatch => {
//     return {
//         getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
//         getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
//         fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
//         processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
//     }
// }

// export default connect(mapStateToProps, mapDispatchToProps)(MaterialRequirementPlanning);

// import React, { Component } from 'react';
// import { InputText } from 'primereact/inputtext';
// import { connect } from 'react-redux';
// import { Dropdown } from 'primereact/dropdown';
// import { Toast } from 'primereact/toast';
// import { Calendar } from 'primereact/calendar';
// import { Button } from 'primereact/button';
// import { DataTable } from 'primereact/datatable';
// import { Column } from 'primereact/column';
// import Messages from '../../../shared/UI/Messages/Messages';
// import axios from '../../../axios-url';

// import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
// import { DATATABLE_CONFIG, DROPDOWN_CONFIG, HOLIDAY_SUBMENU_ID } from '../../../shared/Config';
// import * as actions from '../../../store/actions/index';


// class MaterialRequirementPlanning extends Component {
//     state = {
//         roles: [],
//         type: 'add',
//         Id: null,
//         UserId: null,
//         EmployeeId: null,
//         RoleId: null,
//         functionalRoleId: [],
//         functionalRoleOptions: [],
//         approvalroles: [],
//         approvalRoleId: null,
//         UserId1: '',
//         FirstName: '',
//         MiddleName: '',
//         LastName: '',
//         EmailId: '',
//         Password: '',
//         MobileNumber: '',
//         Activedirectory: false,
//         Adloginid: '',
//         Disablelogin: false,
//         IsActive: false,
//         createdBy: (this.props.loggedUserDetail.userName) ?? 'Admin',
//         createdDate: new Date(),
//         CompanyId: this.props.loggedUserDetail.CompanyId,
//         touch: false,
//         fromDate: null,
//         toDate: null,
//         restaurantId: null,
//         restaurantOptions: [],
//         Menuitems: [],
//         rowSeq: 0,
//         branch: '',
//         recipeDetails: []
//     }

//     // ─── Row Templates ───────────────────────────────────────────────────────────

//     ItemTemplate = (rowData) => {
//         return (
//             <Dropdown
//                 placeholder="Select Item"
//                 showClear
//                 options={this.props.MenuItem}
//                 value={rowData.Item}
//                 onChange={(e) => this.rowChange(e, rowData, 'Item')}
//                 optionLabel="label"
//                 optionValue="value"
//                 {...DROPDOWN_CONFIG}
//             />
//         );
//     }

//     QuantityTemplate = (rowData) => {
//         return (
//             <InputText
//                 className="p-col-12"
//                 value={rowData.Quantity}
//                 placeholder="Quantity"
//                 onChange={(e) => this.rowChange(e, rowData, 'Quantity')}
//             />
//         );
//     }

//     actionTemplate = (rowData) => {
//         return (
//             <Button icon="pi pi-trash" className="p-button-danger" onClick={() => this.removeRow(rowData)} />
//         );
//     }

//     // ─── Reusable Label Resolver ─────────────────────────────────────────────────

//     resolveLabel = (reduxList, value) => {
//         const match = reduxList?.find(item => item.value === value);
//         return match ? match.label : value;
//     }

//     // ─── Lifecycle ───────────────────────────────────────────────────────────────

//     componentDidMount() {
//         this.getAccess = HASACCESS(HOLIDAY_SUBMENU_ID);
//         let id = this.props.match.params.id;
//         this.props.getMasterTableList('GeUsers?id=' + id);
//         this.props.getMasterKeywordList('Unit');
//         this.props.getMasterKeywordList('MenuItem');
//         this.props.getMasterKeywordList('Uom');
//         this.props.getMasterKeywordList('Ingredient');
//         this.props.getMasterKeywordList('branch');
//         let type = this.props.match.params.type;

//         if (type !== 'add') {
//             this.timer();
//         }
//     }

//     timer = () => {
//         this.intervalID = setInterval(() => {
//             this.fetchSingleProcess();
//         }, 2000)
//     }

//     componentWillUnmount() {
//         if (this.props.tableLists.usersList !== undefined) {
//             clearInterval(this.intervalID);
//         }
//     }

//     fetchSingleProcess = () => {
//         let type = this.props.match.params.type;
//         let storageItems = [];
//         if (this.props.tableLists.usersList !== undefined) {
//             storageItems = this.props.tableLists.users;
//             clearInterval(this.intervalID);
//         }
//         if (storageItems) {
//             let filterData = storageItems;
//             if (filterData) {
//                 let roles = '';
//                 let functionalRoles = '';
//                 let approvalroles = '';
//                 if (filterData.roleAssigned != null) {
//                     roles = filterData.roleAssigned.split(",")
//                 }
//                 if (filterData.functionalRole != null) {
//                     functionalRoles = filterData.functionalRole.split(",")
//                 }
//                 if (filterData.approvalrole != null) {
//                     approvalroles = filterData.approvalrole.split(",")
//                 }
//                 var data = {
//                     type: type,
//                     Id: filterData.id,
//                     UserId: filterData.userId,
//                     EmployeeId: filterData.employeeId,
//                     RoleId: roles,
//                     approvalRoleId: approvalroles,
//                     UserId1: filterData.userid1,
//                     FirstName: filterData.firstName,
//                     functionalRoleId: functionalRoles,
//                     MiddleName: filterData.middleName,
//                     LastName: filterData.lastName,
//                     EmailId: filterData.emailId,
//                     Password: filterData.password,
//                     MobileNumber: filterData.mobileNumber,
//                     Activedirectory: filterData.activedirectory,
//                     Adloginid: filterData.adloginid,
//                     Disablelogin: filterData.disablelogin,
//                     IsActive: filterData.isActive,
//                     CreatedBy: filterData.createdby,
//                     CreatedDate: filterData.createddate,
//                 }
//                 this.setState(data);
//             }
//         }
//     }

//     // ─── Handlers ────────────────────────────────────────────────────────────────

//     change = (e) => {
//         let { name, value } = e.target;
//         this.setState({ [name]: value, touch: true })
//     }

//     handleChange = (e) => {
//         const { name, value } = e.target;
//         this.setState({ [name]: value });
//     }

//     rowChange = (e, rowData, field) => {
//         const value = e.value !== undefined ? e.value : e.target.value;
//         const Menuitems = this.state.Menuitems.map(row =>
//             row.rowId === rowData.rowId
//                 ? { ...row, [field]: value }
//                 : row
//         );
//         this.setState({ Menuitems, touch: true });
//     }

//     // ─── Row Operations ──────────────────────────────────────────────────────────

//     addRow = () => {
//         let newRow = {
//             rowId: this.state.rowSeq,
//             Item: '',
//             Quantity: '',
//             Unit: null
//         };
//         this.setState({
//             Menuitems: [...this.state.Menuitems, newRow],
//             rowSeq: this.state.rowSeq + 1,
//             touch: true
//         });
//     }

//     removeRow = (rowData) => {
//         let excludeIds = [rowData.rowId, ...this.getDescendantIds(rowData.rowId)];
//         let Menuitems = this.state.Menuitems.filter(row => !excludeIds.includes(row.rowId));
//         this.setState({ Menuitems, touch: true });
//     }

//     getDescendantIds = (rowId) => {
//         let descendants = [];
//         let children = this.state.Menuitems.filter(row => row.parent === rowId);
//         children.forEach(child => {
//             descendants.push(child.rowId);
//             descendants = [...descendants, ...this.getDescendantIds(child.rowId)];
//         });
//         return descendants;
//     }

//     // ─── API Calls ───────────────────────────────────────────────────────────────

//     generate = () => {
//         if (!this.state.fromDate) {
//             this.growl.show({ severity: 'error', summary: null, detail: 'From Date is required' });
//             return;
//         }
//         if (!this.state.toDate) {
//             this.growl.show({ severity: 'error', summary: null, detail: 'To Date is required' });
//             return;
//         }
//         if (!this.state.branch) {
//             this.growl.show({ severity: 'error', summary: null, detail: 'Restaurant/Kitchen is required' });
//             return;
//         }

//         const companyId = this.state.CompanyId;
//         const fromDate = this.state.fromDate.toISOString();
//         const toDate = this.state.toDate.toISOString();

//         axios.post(`/master/api/res/GetMenuForecast?companyId=${companyId}&FromDate=${fromDate}&ToDate=${toDate}&OutLet=00000000-0000-0000-0000-000000000001`)
//             .then(response => {
//                 const Menuitems = response.data.map((item, index) => ({
//                     rowId: index,
//                     Item: item.menuItemId,
//                     Quantity: item.forecastQuantity,
//                     Unit: item.unitId
//                 }));
//                 this.setState({ Menuitems, rowSeq: response.data.length });
//                 this.growl.show({ severity: 'success', summary: null, detail: 'Menu Forecast generated successfully' });
//             })
//             .catch(error => {
//                 this.growl.show({ severity: 'error', summary: null, detail: 'Failed to generate menu forecast' });
//             });
//     }

//     calculate = () => {
//         if (this.state.Menuitems.length === 0) {
//             this.growl.show({ severity: 'error', summary: null, detail: 'Please add at least one menu item' });
//             return;
//         }

//         const requestBody = this.state.Menuitems.map(row => ({
//             menuItemId: row.Item,
//             qty: parseFloat(row.Quantity)
//         }));

//         const companyId = this.state.CompanyId;

//         axios.post(`/master/api/res/CalculateRecipe?companyId=${companyId}`, requestBody)
//             .then(response => {
//                 const recipeDetails = response.data.map((item, index) => ({
//                     rowId: index,
//                     Item: item.ingredientId,
//                     Quantity: item.requiredQuantity,
//                     Unit: item.uomId
//                 }));
//                 this.setState({ recipeDetails });
//                 this.growl.show({ severity: 'success', summary: null, detail: 'Recipe calculated successfully' });
//             })
//             .catch(error => {
//                 this.growl.show({ severity: 'error', summary: null, detail: 'Failed to calculate recipe' });
//             });
//     }

//     resetData = () => {
//         this.setState({
//             UserId: null,
//             EmployeeId: null,
//             RoleId: null,
//             functionalRoleId: null,
//             approvalRoleId: null,
//             UserId1: '',
//             FirstName: '',
//             MiddleName: '',
//             LastName: '',
//             EmailId: '',
//             Password: '',
//             MobileNumber: '',
//             Activedirectory: false,
//             Disablelogin: false,
//             IsActive: false,
//             type: 'add',
//             fromDate: null,
//             toDate: null,
//             branch: '',
//             Menuitems: [],
//             rowSeq: 0,
//             recipeDetails: []
//         });
//     }

//     updateData = () => {
//         this.growl.show({ severity: 'success', summary: null, detail: 'Material Requirement Planning Updated Successfully' });
//     }

//     // ─── Render ──────────────────────────────────────────────────────────────────

//     render() {
//         if (this.props.success) {
//             REDIRECT_TO_URL('/users/', this.props);
//         }

//         let addAccess = true;
//         let editAccess = true;
//         if (this.getAccess !== undefined) {
//             if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) {
//                 this.props.history.push('/dashboard')
//             }
//             addAccess = (this.getAccess.addAccess === true) ? true : false;
//             editAccess = (this.getAccess.editAccess === true) ? true : false;
//         }

//         const header = () => { }

//         return (
//             <div className="p-grid">
//                 {this.props.loading && <div className="page-loader"></div>}
//                 {this.props.error !== null && <Messages type="error" message={this.props.error} />}
//                 {this.props.success !== null && <Messages type="success" message={this.props.success} />}
//                 <Toast ref={(el) => this.growl = el} />

//                 <div className="p-col-12">
//                     {/* Main Card Container */}
//                     <div className="card card-w-title" style={{ position: 'relative', paddingBottom: '20px' }}>
//                         <h1>Material Requirement Planning</h1>

//                         {/* From Date, To Date, Restaurant/Kitchen Section */}
//                         <div className="p-grid mt1">
//                             <div className="p-col-12">
//                                 <div className="card card-w-title" style={{ marginBottom: '0' }}>
//                                     <div className="p-grid">
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="labeltop" htmlFor="fromDate">From Date</label>
//                                             <div className="mt1">
//                                                 <Calendar className="width100" placeholder="From Date" name="fromDate" value={this.state.fromDate} onChange={this.handleChange} disabled={false} />
//                                             </div>
//                                         </div>

//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="labeltop" htmlFor="toDate">To Date</label>
//                                             <div className="mt1">
//                                                 <Calendar className="width100" placeholder="To Date" name="toDate" value={this.state.toDate} onChange={this.handleChange} disabled={false} />
//                                             </div>
//                                         </div>

//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="label">Restaurant/Kitchen <span className="requiredColor">*</span></label>
//                                             <div className="mt1">
//                                                 <Dropdown
//                                                     className="p-col-12"
//                                                     options={this.props.branch}
//                                                     value={this.state.branch}
//                                                     optionLabel="label"
//                                                     optionValue="value"
//                                                     onChange={this.handleChange}
//                                                     placeholder="Select Restaurant/Kitchen"
//                                                     name="branch"
//                                                     {...DROPDOWN_CONFIG}
//                                                 />
//                                             </div>
//                                         </div>

//                                         <div className="p-col-12 p-md-6 p-lg-12">
//                                             <Button style={{ float: 'right' }} label="Generate" className="ml1 p-button-secondary" onClick={this.generate} />
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Menu Section */}
//                         <div className="p-grid mt1" style={{ marginTop: '20px' }}>
//                             <div className="p-col-12">
//                                 <div className="p-col-12" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                     <h3 style={{ borderBottom: '2px solid #d0d0d0', paddingBottom: '6px', marginBottom: '10px', marginTop: '10px', flex: 1 }}>Menu</h3>
//                                     <Button label="Add Row" icon="pi pi-plus" className="p-button-success" onClick={this.addRow} style={{ marginLeft: '10px' }} />
//                                 </div>

//                                 <div className="p-grid" style={{ marginTop: '20px' }}>
//                                     <div className="p-col-12">
//                                         <DataTable value={this.state.Menuitems} dataKey="rowId" responsiveLayout="scroll">
//                                             <Column field="Item"     header="Menu Item" body={this.ItemTemplate} />
//                                             <Column field="Quantity" header="Quantity"  body={this.QuantityTemplate} />
//                                             <Column                  header="Action"    body={this.actionTemplate} />
//                                         </DataTable>

//                                         {/* Reset & Calculate */}
//                                         <div style={{ marginTop: '20px', textAlign: 'right' }}>
//                                             <Button label="Reset"     className="p-button-secondary" onClick={this.resetData}  style={{ marginRight: '10px' }} />
//                                             <Button label="Calculate" className="p-button-secondary" onClick={this.calculate} />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Ingredients Section */}
//                                 <div className="p-col-12" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                     <h3 style={{ borderBottom: '2px solid #d0d0d0', paddingBottom: '6px', marginBottom: '10px', marginTop: '10px', flex: 1 }}>Ingredients</h3>
//                                 </div>

//                                 <DataTable ref={(el) => this.dt = el} value={this.state.recipeDetails} globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG}>
//                                     <Column header="Ingredient Name" body={(row) => this.resolveLabel(this.props.Ingredient, row.Item)} />
//                                     <Column header="Quantity"        field="Quantity" />
//                                     <Column header="Unit"            body={(row) => this.resolveLabel(this.props.Uom, row.Unit)} />
//                                     <Column header="Action"          body={this.actionTemplate} />
//                                 </DataTable>

//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Issue to Store Section */}
//                 <div className="p-col-12 p-md-6 p-lg-12">
//                     <div className="p-col-12 p-md-6 p-lg-4">
//                         <label className="label">Issue to store <span className="requiredColor">*</span></label>
//                         <div className="mt1">
//                             <Dropdown
//                                 className="p-col-12"
//                                 options={this.state.restaurantOptions}
//                                 value={this.state.restaurantId}
//                                 onChange={this.handleChange}
//                                 placeholder="Select Issue to store"
//                                 name="restaurantId"
//                                 {...DROPDOWN_CONFIG}
//                             />
//                         </div>
//                     </div>
//                     <Button style={{ float: 'right' }} label="Issue to store" className="ml1 p-button-secondary" onClick={this.updateData} />
//                 </div>

//             </div>
//         );
//     }
// }

// const mapStateToProps = state => {
//     return {
//         loggedUserDetail: state.auth.userObject,
//         userDetail:       state.auth.userDetail,
//         userPref:         state.auth.userPref,
//         loading:          state.master.loading,
//         error:            state.master.error,
//         success:          state.master.success,
//         tableLists:       state.master.tableLists,
//         Unit:             (state.keyword.Unit       !== undefined) ? state.keyword.Unit       : [],
//         MenuItem:         (state.keyword.MenuItem   !== undefined) ? state.keyword.MenuItem   : [],
//         Uom:              (state.keyword.Uom        !== undefined) ? state.keyword.Uom        : [],
//         Ingredient:       (state.keyword.Ingredient !== undefined) ? state.keyword.Ingredient : [],
//         branch:           (state.keyword.branch     !== undefined) ? state.keyword.branch     : [],
//     }
// }

// const mapDispatchToProps = dispatch => {
//     return {
//         getMasterTableList:  (table)                    => dispatch(actions.getMasterTableList(table)),
//         getMasterKeywordList:(value)                    => dispatch(actions.getMasterKeywordList(value)),
//         fetchRelavantLists:  (value)                    => dispatch(actions.fetchRelavantLists(value)),
//         processDynamicData:  (model, type, data, func)  => dispatch(actions.processDynamicData(model, type, data, func)),
//     }
// }

// export default connect(mapStateToProps, mapDispatchToProps)(MaterialRequirementPlanning);

import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';

import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DATATABLE_CONFIG, DROPDOWN_CONFIG, HOLIDAY_SUBMENU_ID } from '../../../shared/Config';
import * as actions from '../../../store/actions/index';

const LOCAL_STORAGE_KEY = 'mrp_recipeDetails';

class MRP extends Component {
    state = {
        roles: [],
        type: 'add',
        Id: null,
        UserId: null,
        EmployeeId: null,
        RoleId: null,
        functionalRoleId: [],
        functionalRoleOptions: [],
        approvalroles: [],
        approvalRoleId: null,
        UserId1: '',
        FirstName: '',
        MiddleName: '',
        LastName: '',
        EmailId: '',
        Password: '',
        MobileNumber: '',
        Activedirectory: false,
        Adloginid: '',
        Disablelogin: false,
        IsActive: false,
        createdBy: (this.props.loggedUserDetail.userName) ?? 'Admin',
        createdDate: new Date(),
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false,
        fromDate: null,
        toDate: null,
        restaurantId: null,
        restaurantOptions: [],
        Menuitems: [],
        rowSeq: 0,
        branch: '',
        recipeDetails: [],         // all ingredients from API
        selectedIngredients: [],   // rows selected in the DataTable
        disabledRowIds: [],        // rowIds already assigned to a PO
        supplierId: null,          // selected supplier
        supplierOptions: [],        // supplier dropdown options
        createGrn: false,
    }

    // ─── Row Templates ───────────────────────────────────────────────────────────

    ItemTemplate = (rowData) => {
        return (
            <Dropdown
                placeholder="Select Item"
                showClear
                options={this.props.MenuItem}
                value={rowData.Item}
                onChange={(e) => this.rowChange(e, rowData, 'Item')}
                optionLabel="label"
                optionValue="value"
                {...DROPDOWN_CONFIG}
            />
        );
    }

    QuantityTemplate = (rowData) => {
        return (
            <InputText
                className="p-col-12"
                value={rowData.Quantity}
                placeholder="Quantity"
                onChange={(e) => this.rowChange(e, rowData, 'Quantity')}
            />
        );
    }

    actionTemplate = (rowData) => {
        return (
            <Button icon="pi pi-trash" className="p-button-danger" onClick={() => this.removeRow(rowData)} />
        );
    }

    // ─── Reusable Label Resolver ─────────────────────────────────────────────────

    resolveLabel = (reduxList, value) => {
        const match = reduxList?.find(item => item.value === value);
        return match ? match.label : value;
    }

    // ─── Local Storage Helpers ───────────────────────────────────────────────────

    saveToLocalStorage = (recipeDetails) => {
        try {
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(recipeDetails));
        } catch (e) {
            console.warn('LocalStorage save failed', e);
        }
    }

    loadFromLocalStorage = () => {
        try {
            const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
            return saved ? JSON.parse(saved) : [];
        } catch (e) {
            return [];
        }
    }

    clearLocalStorage = () => {
        localStorage.removeItem(LOCAL_STORAGE_KEY);
    }

    // ─── Lifecycle ───────────────────────────────────────────────────────────────

    componentDidMount() {
        this.getAccess = HASACCESS(HOLIDAY_SUBMENU_ID);
        let id = this.props.match.params.id;
        this.props.getMasterTableList('GeUsers?id=' + id);
        this.props.getMasterKeywordList('Unit');
        this.props.getMasterKeywordList('MenuItem');
        this.props.getMasterKeywordList('Uom');
        this.props.getMasterKeywordList('Ingredient');
        this.props.getMasterKeywordList('branch');
        this.props.getMasterKeywordList('Vendor');
        let type = this.props.match.params.type;

        // Restore ingredients from localStorage on mount
        const saved = this.loadFromLocalStorage();
        if (saved.length > 0) {
            this.setState({ recipeDetails: saved });
        }

        if (type !== 'add') {
            this.timer();
        }
    }

    timer = () => {
        this.intervalID = setInterval(() => {
            this.fetchSingleProcess();
        }, 2000)
    }

    componentWillUnmount() {
        if (this.props.tableLists.usersList !== undefined) {
            clearInterval(this.intervalID);
        }
    }

    fetchSingleProcess = () => {
        let type = this.props.match.params.type;
        let storageItems = [];
        if (this.props.tableLists.usersList !== undefined) {
            storageItems = this.props.tableLists.users;
            clearInterval(this.intervalID);
        }
        if (storageItems) {
            let filterData = storageItems;
            if (filterData) {
                let roles = '';
                let functionalRoles = '';
                let approvalroles = '';
                if (filterData.roleAssigned != null) roles = filterData.roleAssigned.split(",");
                if (filterData.functionalRole != null) functionalRoles = filterData.functionalRole.split(",");
                if (filterData.approvalrole != null) approvalroles = filterData.approvalrole.split(",");

                var data = {
                    type: type,
                    Id: filterData.id,
                    UserId: filterData.userId,
                    EmployeeId: filterData.employeeId,
                    RoleId: roles,
                    approvalRoleId: approvalroles,
                    UserId1: filterData.userid1,
                    FirstName: filterData.firstName,
                    functionalRoleId: functionalRoles,
                    MiddleName: filterData.middleName,
                    LastName: filterData.lastName,
                    EmailId: filterData.emailId,
                    Password: filterData.password,
                    MobileNumber: filterData.mobileNumber,
                    Activedirectory: filterData.activedirectory,
                    Adloginid: filterData.adloginid,
                    Disablelogin: filterData.disablelogin,
                    IsActive: filterData.isActive,
                    CreatedBy: filterData.createdby,
                    CreatedDate: filterData.createddate,
                }
                this.setState(data);
            }
        }
    }

    // ─── Handlers ────────────────────────────────────────────────────────────────

    change = (e) => {
        let { name, value } = e.target;
        this.setState({ [name]: value, touch: true });
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    rowChange = (e, rowData, field) => {
        const value = e.value !== undefined ? e.value : e.target.value;
        const Menuitems = this.state.Menuitems.map(row =>
            row.rowId === rowData.rowId ? { ...row, [field]: value } : row
        );
        this.setState({ Menuitems, touch: true });
    }

    // ─── Row Operations ──────────────────────────────────────────────────────────

    addRow = () => {
        let newRow = { rowId: this.state.rowSeq, Item: '', Quantity: '', Unit: null };
        this.setState({
            Menuitems: [...this.state.Menuitems, newRow],
            rowSeq: this.state.rowSeq + 1,
            touch: true
        });
    }

    removeRow = (rowData) => {
        let excludeIds = [rowData.rowId, ...this.getDescendantIds(rowData.rowId)];
        let Menuitems = this.state.Menuitems.filter(row => !excludeIds.includes(row.rowId));
        this.setState({ Menuitems, touch: true });
    }

    getDescendantIds = (rowId) => {
        let descendants = [];
        let children = this.state.Menuitems.filter(row => row.parent === rowId);
        children.forEach(child => {
            descendants.push(child.rowId);
            descendants = [...descendants, ...this.getDescendantIds(child.rowId)];
        });
        return descendants;
    }

    // ─── Supplier mapping ────────────────────────────────────────────────────────

    // Union of the approved vendor IDs (comma-separated "approvedvendors" from CalculateRecipe)
    // of the selected ingredients, or of all pending ingredients when none is selected.
    // IDs are matched case-insensitively against the Vendor options and returned using the
    // option's own value so the MultiSelect can tick them.
    getApprovedSupplierValues = () => {
        const { recipeDetails, selectedIngredients } = this.state;
        const options = this.props.Vendor || [];
        const rows = selectedIngredients.length > 0
            ? selectedIngredients
            : recipeDetails.filter(row => !row.poGenerated);

        const ids = new Set();
        rows.forEach(row => {
            String(row.approvedVendors || '').split(',').forEach(id => {
                const trimmed = id.trim().toLowerCase();
                if (trimmed) ids.add(trimmed);
            });
        });

        return options
            .filter(option => option && ids.has(String(option.value).toLowerCase()))
            .map(option => option.value);
    }

    // ─── PO Generation ───────────────────────────────────────────────────────────

    generatePO = () => {
        const { selectedIngredients, disabledRowIds } = this.state;
        const supplierId = this.getApprovedSupplierValues();

        if (selectedIngredients.length === 0) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Please select at least one ingredient' });
            return;
        }
        if (supplierId.length === 0) {
            this.growl.show({ severity: 'error', summary: null, detail: 'No approved supplier found for the selected ingredients' });
            return;
        }

        // Collect rowIds of selected rows and mark them as disabled
        const newlyDisabledIds = selectedIngredients.map(row => row.rowId);
        const updatedDisabledIds = [...disabledRowIds, ...newlyDisabledIds];

        // Mark selected rows as disabled in recipeDetails
        const updatedRecipeDetails = this.state.recipeDetails.map(row =>
            newlyDisabledIds.includes(row.rowId)
                ? { ...row, poGenerated: true }
                : row
        );

        // Persist updated state to localStorage
        this.saveToLocalStorage(updatedRecipeDetails);

        this.setState({
            disabledRowIds: updatedDisabledIds,
            recipeDetails: updatedRecipeDetails,
            selectedIngredients: [],   // clear selection after PO
            supplierId: null
        });

        this.growl.show({ severity: 'success', summary: null, detail: `PO generated for ${newlyDisabledIds.length} ingredient(s) successfully` });
    }

    // ─── API Calls ───────────────────────────────────────────────────────────────

    generate = () => {
        if (!this.state.fromDate) {
            this.growl.show({ severity: 'error', summary: null, detail: 'From Date is required' });
            return;
        }
        if (!this.state.toDate) {
            this.growl.show({ severity: 'error', summary: null, detail: 'To Date is required' });
            return;
        }
        if (!this.state.branch) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Restaurant/Kitchen is required' });
            return;
        }

        const companyId = this.state.CompanyId;
        const fromDate = this.state.fromDate.toISOString();
        const toDate = this.state.toDate.toISOString();

        axios.post(`/master/api/res/GetMenuForecast?companyId=${companyId}&FromDate=${fromDate}&ToDate=${toDate}&OutLet=00000000-0000-0000-0000-000000000001`)
            .then(response => {
                const Menuitems = response.data.map((item, index) => ({
                    rowId: index,
                    Item: item.menuItemId,
                    Quantity: item.forecastQuantity,
                    Unit: item.unitId
                }));
                this.setState({ Menuitems, rowSeq: response.data.length });
                this.growl.show({ severity: 'success', summary: null, detail: 'Menu Forecast generated successfully' });
            })
            .catch(() => {
                this.growl.show({ severity: 'error', summary: null, detail: 'Failed to generate menu forecast' });
            });
    }

    calculate = () => {
        if (this.state.Menuitems.length === 0) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Please add at least one menu item' });
            return;
        }

        const requestBody = this.state.Menuitems.map(row => ({
            menuItemId: row.Item,
            qty: parseFloat(row.Quantity)
        }));

        axios.post(`/master/api/res/CalculateRecipe?companyId=${this.state.CompanyId}`, requestBody)
            .then(response => {
                const recipeDetails = response.data.map((item, index) => ({
                    rowId: index,
                    Item: item.ingredientId,
                    Quantity: item.requiredQuantity,
                    Unit: item.uomId,
                    approvedVendors: item.approvedvendors || '',
                    poGenerated: false
                }));
                // Save fresh results to localStorage
                this.saveToLocalStorage(recipeDetails);
                this.setState({ recipeDetails, selectedIngredients: [], disabledRowIds: [] });
                this.growl.show({ severity: 'success', summary: null, detail: 'Recipe calculated successfully' });
            })
            .catch(() => {
                this.growl.show({ severity: 'error', summary: null, detail: 'Failed to calculate recipe' });
            });
    }

    resetData = () => {
        this.clearLocalStorage();
        this.setState({
            UserId: null,
            EmployeeId: null,
            RoleId: null,
            functionalRoleId: null,
            approvalRoleId: null,
            UserId1: '',
            FirstName: '',
            MiddleName: '',
            LastName: '',
            EmailId: '',
            Password: '',
            MobileNumber: '',
            Activedirectory: false,
            Disablelogin: false,
            IsActive: false,
            type: 'add',
            fromDate: null,
            toDate: null,
            branch: '',
            Menuitems: [],
            rowSeq: 0,
            recipeDetails: [],
            selectedIngredients: [],
            disabledRowIds: [],
            supplierId: null
        });
    }

    updateData = () => {
        this.growl.show({ severity: 'success', summary: null, detail: 'Material Requirement Planning Updated Successfully' });
    }

    // ─── Render ──────────────────────────────────────────────────────────────────

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/users/', this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) {
                this.props.history.push('/dashboard');
            }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }

        const { recipeDetails, selectedIngredients, disabledRowIds } = this.state;

        // Rows available for selection = not yet PO-generated
        const selectableRows = recipeDetails.filter(row => !row.poGenerated);

        const header = () => { }

        // Row class: grey out disabled rows
        const rowClassName = (rowData) => {
            return rowData.poGenerated ? { 'p-disabled-row': true } : {};
        }

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />

                <style>{`
                    .p-disabled-row { opacity: 0.45; pointer-events: none; background: #f4f4f4; }
                    .po-badge { background: #28a745; color: #fff; padding: 2px 8px; border-radius: 12px; font-size: 11px; font-weight: 600; margin-left: 8px; }
                `}</style>

                <div className="p-col-12">
                    {/* Main Card Container */}
                    <div className="card card-w-title" style={{ position: 'relative', paddingBottom: '20px' }}>
                        <h1>Material Requirement Planning</h1>

                        {/* From Date, To Date, Restaurant/Kitchen Section */}
                        <div className="p-grid mt1">
                            <div className="p-col-12">
                                <div className="card card-w-title" style={{ marginBottom: '0' }}>
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="fromDate">From Date</label>
                                            <div className="mt1">
                                                <Calendar className="width100" placeholder="From Date" name="fromDate" value={this.state.fromDate} onChange={this.handleChange} />
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="toDate">To Date</label>
                                            <div className="mt1">
                                                <Calendar className="width100" placeholder="To Date" name="toDate" value={this.state.toDate} onChange={this.handleChange} />
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Restaurant/Kitchen <span className="requiredColor">*</span></label>
                                            <div className="mt1">
                                                <Dropdown
                                                    className="p-col-12"
                                                    options={this.props.branch}
                                                    value={this.state.branch}
                                                    optionLabel="label"
                                                    optionValue="value"
                                                    onChange={this.handleChange}
                                                    placeholder="Select Restaurant/Kitchen"
                                                    name="branch"
                                                    {...DROPDOWN_CONFIG}
                                                />
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-6 p-lg-12">
                                            <Button style={{ float: 'right' }} label="Generate" className="ml1 p-button-secondary" onClick={this.generate} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Menu Section */}
                        <div className="p-grid mt1" style={{ marginTop: '20px' }}>
                            <div className="p-col-12">
                                <div className="p-col-12" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h3 style={{ borderBottom: '2px solid #d0d0d0', paddingBottom: '6px', marginBottom: '10px', marginTop: '10px', flex: 1 }}>Menu</h3>
                                    <Button label="Add Row" icon="pi pi-plus" className="p-button-success" onClick={this.addRow} style={{ marginLeft: '10px' }} />
                                </div>

                                <div className="p-grid" style={{ marginTop: '20px' }}>
                                    <div className="p-col-12">
                                        <DataTable value={this.state.Menuitems} dataKey="rowId" responsiveLayout="scroll">
                                            <Column field="Item"     header="Menu Item" body={this.ItemTemplate} />
                                            <Column field="Quantity" header="Quantity"  body={this.QuantityTemplate} />
                                            <Column                  header="Action"    body={this.actionTemplate} />
                                        </DataTable>

                                        <div style={{ marginTop: '20px', textAlign: 'right' }}>
                                            <Button label="Reset"     className="p-button-secondary" onClick={this.resetData} style={{ marginRight: '10px' }} />
                                            <Button label="Calculate" className="p-button-secondary" onClick={this.calculate} />
                                        </div>
                                    </div>
                                </div>

                                {/* ── Ingredients Section ── */}
                                <div className="p-col-12" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h3 style={{ borderBottom: '2px solid #d0d0d0', paddingBottom: '6px', marginBottom: '10px', marginTop: '10px', flex: 1 }}>
                                        Ingredients
                                        {recipeDetails.length > 0 && (
                                            <span style={{ fontSize: '13px', fontWeight: 'normal', color: '#888', marginLeft: '10px' }}>
                                                ({selectableRows.length} available, generated Po for {disabledRowIds.length} )
                                            </span>
                                        )}
                                    </h3>
                                </div>

                                {/* Ingredients DataTable with row selection */}
                                <DataTable
                                    ref={(el) => this.dt = el}
                                    value={recipeDetails}
                                    globalFilter={this.state.globalFilter}
                                    header={header}
                                    dataKey="rowId"
                                    selection={selectedIngredients}
                                    onSelectionChange={(e) => {
                                        // Only allow selecting non-PO rows
                                        const filtered = e.value.filter(row => !row.poGenerated);
                                        this.setState({ selectedIngredients: filtered });
                                    }}
                                    isDataSelectable={(e) => !e.data.poGenerated}
                                    rowClassName={rowClassName}
                                    {...DATATABLE_CONFIG}
                                >
                                    <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                                    <Column
                                        header="Ingredient Name"
                                        body={(row) => (
                                            <span>
                                                {this.resolveLabel(this.props.Ingredient, row.Item)}
                                                {row.poGenerated && <span className="po-badge">PO Generated</span>}
                                            </span>
                                        )}
                                    />
                                    <Column header="Quantity" field="Quantity" />
                                    <Column header="Unit"     body={(row) => this.resolveLabel(this.props.Uom, row.Unit)} />
                                </DataTable>

                                {/* ── Supplier + Generate PO ── */}
                                {recipeDetails.length > 0 && (
                                    <div className="p-grid" style={{ marginTop: '20px', alignItems: 'flex-end' }}>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Select Supplier <span className="requiredColor">*</span></label>
                                            <div className="mt1">
                                                {/* Not `disabled` so the panel can still be opened to view the
                                                    selected vendors; the no-op onChange keeps it non-editable. */}
                                                <MultiSelect
                                                    className="p-col-12"
                                                    options={this.props.Vendor || []}
                                                    value={this.getApprovedSupplierValues()}
                                                    optionLabel="label"
                                                    optionValue="value"
                                                    onChange={() => {}}
                                                    display="chip"
                                                    placeholder="Select Supplier"
                                                    selectedItemsLabel="{0} suppliers selected"
                                                    maxSelectedLabels={3}
                                                    {...DROPDOWN_CONFIG}
                                                />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-8" style={{ textAlign: 'right' }}>
                                            <Button
                                                label={`Generate PO${selectedIngredients.length > 0 ? ` (${selectedIngredients.length} selected)` : ''}`}
                                                icon="pi pi-file"
                                                className="p-button-primary"
                                                onClick={this.generatePO}
                                                disabled={selectedIngredients.length === 0 || this.getApprovedSupplierValues().length === 0}
                                            />
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>

                {/* Issue to Store Section */}
                <div className="p-col-12 p-md-6 p-lg-12">
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="label">Issue to store <span className="requiredColor">*</span></label>
                        <div className="mt1">
                            <Dropdown
                                className="p-col-12"
                                options={this.state.restaurantOptions}
                                value={this.state.restaurantId}
                                onChange={this.handleChange}
                                placeholder="Select Issue to store"
                                name="restaurantId"
                                {...DROPDOWN_CONFIG}
                            />
                        </div>
                    </div>

                    {/* ✅ Create GRN checkbox in same line */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '20px' }}>
                        <input
                            type="checkbox"
                            id="createGrn"
                            checked={this.state.createGrn || false}
                            onChange={(e) => this.setState({ createGrn: e.target.checked })}
                            style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                        />
                        <label htmlFor="createGrn" style={{ cursor: 'pointer', marginBottom: 0 }}>
                            Create GRN
                        </label>
                    </div>

                    <Button style={{ float: 'right' }} label="Issue to store" className="ml1 p-button-secondary" onClick={this.updateData} />
                </div>
            </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail:       state.auth.userDetail,
        userPref:         state.auth.userPref,
        loading:          state.master.loading,
        error:            state.master.error,
        success:          state.master.success,
        tableLists:       state.master.tableLists,
        Unit:             (state.keyword.Unit       !== undefined) ? state.keyword.Unit       : [],
        MenuItem:         (state.keyword.MenuItem   !== undefined) ? state.keyword.MenuItem   : [],
        Uom:              (state.keyword.Uom        !== undefined) ? state.keyword.Uom        : [],
        Ingredient:       (state.keyword.Ingredient !== undefined) ? state.keyword.Ingredient : [],
        branch:           (state.keyword.branch     !== undefined) ? state.keyword.branch     : [],
        Vendor:           (state.keyword.Vendor     !== undefined) ? state.keyword.Vendor     : [],}
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList:   (table)                   => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList: (value)                   => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists:   (value)                   => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData:   (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MRP);